import AccountDeactivateChild from "../../components/AccountDeactivateChild";
import React from "react";

export default function AccountDeactivate() {
  return (
    <div>
      <AccountDeactivateChild />
    </div>
  );
}
